// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ni[data-v-4a6001b7] {\n    color: white;\n}\n", ""]);
// Exports
module.exports = exports;
